module.exports = __webpack_public_path__ + "images/emoji/cancer.67afc1d12b70fc94983b.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/cancer.png
// module id = 3Jee
// module chunks = 1